import { atom, useAtom, useSetAtom } from "jotai";

export const posShowPayment = false;

export const posShowPaymentAtom = atom<boolean>(posShowPayment);

const usePosShowPayment = () => {
  const atom = useAtom(posShowPaymentAtom);
  return atom;
};

export const useSetPosShowPayment = () => useSetAtom(posShowPaymentAtom);

export default usePosShowPayment;
